import type { PhoneLock } from '@/api/endpoints/settings'
import { formatRelativeDate } from '@/lib/format'

export const PIN_PATTERN = /^\d{6,16}$/

/** A frase de estado do PIN do celular, acima do formulário. */
export function phoneLockSummary(lock: PhoneLock): { tone: 'ok' | 'warn' | 'muted'; text: string } {
  if (!lock.configured) {
    return { tone: 'muted', text: 'Nenhum PIN salvo. Sem PIN, o celular precisa ficar sem bloqueio de tela.' }
  }
  if (lock.failures >= lock.max_failures) {
    return {
      tone: 'warn',
      text: `O PIN salvo errou ${String(lock.failures)} vezes seguidas. O Prism não tenta mais até você salvar o PIN de novo.`,
    }
  }
  if (lock.state === 'blocked') {
    const why = lock.last_error ? ` (${lock.last_error})` : ''
    return {
      tone: 'warn',
      text: `Desbloqueio automático parado depois de um erro${why}, ${String(lock.failures)} de ${String(lock.max_failures)}. Confira o PIN no aparelho e use "Desbloquear agora".`,
    }
  }
  if (lock.state === 'armed') {
    const when = lock.last_ok_at ? ` ${formatRelativeDate(lock.last_ok_at)}` : ''
    return { tone: 'ok', text: `PIN conferido${when}. A automação destrava o celular sozinha.` }
  }
  const when = lock.set_at ? ` ${formatRelativeDate(lock.set_at)}` : ''
  return {
    tone: 'warn',
    text: `PIN salvo${when}, ainda não conferido. Use "Desbloquear agora" com o celular à vista; até lá a automação não digita o PIN.`,
  }
}
